'use client'

import styled from 'styled-components'

import { ExpansionPanel, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div<{ $inKit?: boolean }>`
  padding-bottom: ${o => (o.$inKit ? o.theme.spacing(2) : o.theme.spacing(5))};
  padding-top: ${o => (o.$inKit ? o.theme.spacing(2) : '0')};
`

export const Inner = styled.div<{
  $inKit?: boolean
}>`
  margin-left: ${o => (o.$inKit ? '16.5px' : 0)};

  ${fromMd} {
    margin-left: ${o => (o.$inKit ? o.theme.spacing(6) : 0)};
  }
`

export const Top = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const Label = styled.span`
  ${TypeStyle.css.bodyMicro};
  font-size: 11px;
  font-weight: bold;
  color: ${o => o.theme.color.stroke.neutral.text.primary.on.background};
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 2px;
`

export const StyledExpansionPanelSummary = styled(ExpansionPanel.Summary)`
  flex-direction: row-reverse;
  gap: ${o => o.theme.spacing(2)};
  justify-content: flex-end;
`
